// extracted by mini-css-extract-plugin
export default {"section":"Offer_section__23VQG","stage":"Offer_stage__FZPZE","title":"Offer_title__8ABf9","text":"Offer_text__eOYyG","btnr":"Offer_btnr__iJz7a"};